

import { ShipmentDetailEditController } from './controllers/shipmentDetailEditController';

import '../../../../../core/directives/readOnlyText/readOnlyTextDirective';
import '../shipmentShippingInfo/shipmentShippingInfoDirective';
import '../shipmentLocation/shipmentLocationDirective';
import '../../models/requestDetailEdit';


export class ShipmentDetailEditDirective implements angular.IDirective {
    template = require('./templates/shipmentDetailEdit.html');
    restrict = 'E';
    controller = ShipmentDetailEditController;
    controllerAs = 'vm';
    bindToController = {
        requestDetailEdit: '=',
        isLoading: '=',
        isValid : '='
    };
    scope = {};
    replace = true;
    static factory(): angular.IDirectiveFactory {
        return () => new ShipmentDetailEditDirective();
    }
}

angular.module('deliveryCreate.app').directive('shipmentDetailEdit', ShipmentDetailEditDirective.factory());



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestDetailEdit/directives/shipmentDetailEdit/shipmentDetailEditDirective.ts
 **/